import React, {useState} from "react";
import SubTagPlentyCard from "../tag/subTag/SubTagPlentyCard";
import {TagListFunctional} from "../tag/TagListFunctional";
import TagListInput from "../tag/TagListInput";
import styled from "styled-components";

const TagInput = ({
                      selectedTags,
                      setSelectedTags,
                      isLimitedItem,
                      actionName
                  }) => {


    const [tagListInputIsShowed, setShowTagListInput] = useState(false)
    return (
        <Container>
            <label>
                Tags :
            </label>
            <TagWrapper onClick={() => {
                setShowTagListInput(true)
            }}
                        id={"tag-list-input"}>
                <div className={"flex-row gap-1"}>

                    <div className={"flex-row gap-05 ai-center"}>
                        {selectedTags &&
                        selectedTags.map(tag => (
                            <SubTagPlentyCard
                                key={tag.id + '/' + tag.name}
                                id={tag.id}
                                color={tag.color}
                                name={tag.name}
                                category={tag.category}
                            />
                        ))}
                    </div>
                </div>
                <TagListFunctional show={tagListInputIsShowed}
                                   onClickOutside={() => {
                                       setShowTagListInput(false)
                                   }}
                                   component={
                                       <TagListInput setSelectedTags={setSelectedTags}
                                                     selectedTags={selectedTags}
                                                     isLimitedItem={isLimitedItem}
                                                     actionName={actionName}/>
                                   }
                />
            </TagWrapper>
        </Container>

    )
}

const Container = styled.div`
    display: flex;
  flex-direction: column;
  gap: 0.5rem;
`
const TagWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1em;
  padding: 1em;
  border-radius: 10px;
  border: 1px solid var(--color-grey-03);
  height: 60px;
  cursor: pointer;
  flex-wrap: wrap;
  overflow-y: auto;

  label {
    display: inline-block;
    white-space: nowrap;

  }

  &:hover {
    background-color: rgba(166, 172, 181, 0.6);
    border-color: transparent;
  }
`


export default TagInput;